import React from "react";
import './Prizes.css';
import ContestPrizes01 from "../../../static/img/Contest/getPrize.svg";
import ContestMenu from "./ContestMenu";
import LayoutMain from "../../../Elements/LayoutMain/LayoutMain";
import IfYouHaveQuestions from "../../../Elements/LayoutMain/IfYouHaveQuestions/IfYouHaveQuestions";
import TextChange from "../../../../AdminPart/src/Elements/TextChange/TextChange";

function GatsbyContestPrizesSource (props) {
        function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
        } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

        return (
        <LayoutMain title={props.title} description={props.description} lang={props.lang} AllMenu={['','ElementMenuActive','','','','']} Active={1}>
            <main className="ContestPrize StandartPage">
                <div className="StandartNOTitle"/>
                <div className="StandartTitleOut AboutTitle StandartIn">
                    <div className="StandartTitle"><TextSource ArrIndex= 'ContestPrizes0015'>Получить приз</TextSource> </div>
                    <IfYouHaveQuestions lang={props.lang}/>
                </div>
                <div className="StandartWhitePart ContestPrizeMainGrid StandartIn">
                        <div className="ContestPrizesGrid">
                            <div className="ContestPrizesGridLeft">
                                <img src={ContestPrizes01} alt='Ifyoudontseeimages'/>
                            </div>
                            <div className="ContestPrizesGridRight">
                                <div className="ContestPrizesGridRightIn">
                                    <div className="ContestPrizesGridRightText01"><TextSource ArrIndex= 'ContestPrizes0020'>Уважаемые участники конкурса - для получения приза. Вам необходимо выслать письмо на почту</TextSource> 
                                    <b><TextSource ArrIndex= 'ContestPrizes0030'>contest@fxbitcoin.org</TextSource> </b></div>
                                    <div className="ContestPrizesGridRightTitle"><TextSource ArrIndex= 'ContestPrizes0035'>В письме укажите</TextSource> </div>
                                    <div className="TraderContestTopGridTextList">
                                        <div className="TraderContestTopGridTextListElement"><TextSource ArrIndex= 'ContestPrizes0040'>Номер конкурсного счета</TextSource> </div>
                                        <div className="TraderContestTopGridTextListElement"><TextSource ArrIndex= 'ContestPrizes0045'>Место, которое Вы заняли на конкурсе и ссылку на результаты</TextSource> </div>
                                        <div className="TraderContestTopGridTextListElement"><TextSource ArrIndex= 'ContestPrizes0050'>Номер торгового счета, на который следует перечислить средства</TextSource> </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <ContestMenu lang={props.lang} data={props.data} MenuElements={['NoActiveElements','NoActiveElements','ActiveElements']}/>

                </div>
            </main>
        </LayoutMain>

    )}

export default GatsbyContestPrizesSource